import OurMessengers from '@/lib/shared/blocks/OurMessengers/OurMessengers';
import { RequestCallNew } from '@/lib/shared/components/Forms';
import { H2, P3 } from '@/lib/shared/components/Typography';

import cn from 'clsx';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';

import styles from './CallBack.module.scss';

import { LeadType } from '../../../entities/lead/model/lead-type';

interface ICallback {
  agreementText?: string;
  title?: string;
  buttonLabel?: string;
  showLeaf?: boolean;
  excludeText?: boolean;
  page?: 'about' | 'complex' | 'landing' | 'landingVillas';
  leadType?: LeadType;
  comment?: string;
  sourceForm?: string;
  eventName: string[];
}

const pageTranslations = {
  CALL_TEXT: {
    about: 'ourExpertsWillAnswer',
    complex: 'applyForConsult',
    landing: '',
    landingVillas: '',
  },
  CALL_TITLE: {
    about: 'askUsAnyQuestion',
    complex: 'helpYouChooseVillaOrApt1',
    landing: 'weWillMakeASelection',
    landingVillas: 'requestASelection',
  },
};
export const CallBack = ({
  showLeaf,
  excludeText,
  page = 'complex',
  buttonLabel = 'apply',
  agreementText = 'policyPermission',
  comment,
  eventName,
  sourceForm,
  ...props
}: ICallback) => {
  const { t } = useTranslation('index');
  const isAboutPage = page === 'about';
  const translatedTitle = pageTranslations.CALL_TITLE[page];
  const translatedText = pageTranslations.CALL_TEXT[page];

  return (
    <div className={cn(styles.call, showLeaf && styles['call--show'])}>
      {page !== 'landing' && (
        <div
          className={cn(
            styles.call__blueLeafWrapper,
            showLeaf && styles['call__blueLeafWrapper--show'],
            isAboutPage && styles['call__blueLeafWrapper--about']
          )}
        >
          <Image
            sizes="1123px"
            className={styles.call__blueLeaf}
            src={'/images/complex/leaf/blue-leaf.webp'}
            alt=""
            fill
          />
        </div>
      )}
      {page !== 'landing' && (
        <div
          className={cn(
            styles.call__goldenLeafWrapper,
            showLeaf && styles['call__goldenLeafWrapper--show']
          )}
        >
          <Image
            sizes="500px"
            className={styles.call__goldenLeaf}
            src={'/images/complex/leaf/golden-leaf.webp'}
            alt=""
            fill
          />
        </div>
      )}
      {page === 'landing' && (
        <div className={styles.call__whiteBlueLeafWrapper}>
          <Image
            sizes="500px"
            className={styles.call__whiteBlueLeafWrapper}
            src={'/images/complex/leaf/white-blue-leaf.webp'}
            alt=""
            fill
          />
        </div>
      )}
      <Image
        sizes="100vw"
        className={styles.call__bg}
        src={'/images/feedBackBg.webp'}
        alt=""
        fill
      />
      <div className={cn(styles.call__content, styles.container)}>
        <div>
          <div className={styles.call__info}>
            <H2 className={styles.call__title}>
              {t(`form.titles.${translatedTitle}`)}
            </H2>
            {!excludeText && translatedText && (
              <P3 className={styles.call__text}>
                {t(`form.subTitles.${translatedText}`)}
              </P3>
            )}
          </div>

          <RequestCallNew
            theme="white"
            className={styles.call__form}
            agreementText={agreementText}
            buttonLabel={buttonLabel}
            includeQuestion={isAboutPage}
            leadType={
              props.leadType || (isAboutPage ? 'NOT_SPECIFIED' : 'SALE')
            }
            comment={comment ? comment : undefined}
            eventName={eventName}
            sourceForm={sourceForm}
            {...props}
          />
        </div>

        <div className={cn(styles.call__messengers, 'ourMessengers-wrapper')}>
          <OurMessengers />
        </div>
      </div>
    </div>
  );
};
